import { useMemo } from 'react';
import { t } from 'i18next';
import { FilterOption } from 'models/Filters';
import useGetFilterOptions from 'hooks/useGetFilterOptions';
import useOperationStepValues from 'router/data/useOperationStepValues';
import useCreateSelectOptions from 'hooks/useCreateSelectOptions';
import { TIMEFRAME } from 'dateUtils';

const useDataRoomInvitationsFilterOptions = () => {
  const { getPriceRangeFilter } = useGetFilterOptions();

  const { locationOptions, industrySelectOptions } =
    useOperationStepValues(true);

  const createSelectOptions = useCreateSelectOptions();

  const timeframeOptions = useMemo(
    () => createSelectOptions(Object.values(TIMEFRAME)),
    [createSelectOptions],
  );

  return useMemo(
    () =>
      [
        getPriceRangeFilter(t('price'), 'dataRoomFrom', 'dataRoomTo'),
        getPriceRangeFilter(
          t('ebitda'),
          'dataRoomEbitdaFrom',
          'dataRoomEbitdaTo',
        ),
        {
          value: 'dataRoomLocation',
          label: t('location'),
          isMultiple: true,
          options: locationOptions,
        },
        {
          value: 'dataRoomIndustry',
          label: t('industry'),
          isMultiple: true,
          isSearchable: true,
          options: industrySelectOptions,
        },
        {
          value: 'dataRoomTimeframe',
          label: t('createdDuring'),
          shouldSortOptions: false,
          options: timeframeOptions,
        },
        {
          value: 'dataRoomInvited',
          label: t('invited'),
          shouldSortOptions: false,
          options: timeframeOptions,
        },
      ] as FilterOption[],
    [
      locationOptions,
      industrySelectOptions,
      timeframeOptions,
      getPriceRangeFilter,
    ],
  );
};

export default useDataRoomInvitationsFilterOptions;
